/** Stable palette so the same trajectoryId keeps the same color across 2D/3D charts. */
const TRAJECTORY_LINE_COLORS = [
  '#4C9AFF',
  '#FF8B00',
  '#36B37E',
  '#6554C0',
  '#FF5630',
  '#00B8D9',
  '#FFC400',
  '#8777D9',
  '#57D9A3',
  '#FF7452',
] as const;

export const MAIN_TRAJECTORY_LINE_WIDTH = 3;
export const REFERENCE_TRAJECTORY_LINE_WIDTH = 2;

export function getTrajectoryLineColor(trajectoryId: number): string {
  const index = Math.abs(trajectoryId) % TRAJECTORY_LINE_COLORS.length;

  return TRAJECTORY_LINE_COLORS[index] ?? TRAJECTORY_LINE_COLORS[0];
}
